import {Injectable} from '@angular/core';
import {SpringLoginResponse} from "@aiknow-srl/aik-ngx-http";
import {BaseOPEService} from "./BaseOPEService";
import {SaveNewPasswordCB} from "../../ope/auth/SaveNewPasswordCB";
import {ResetPasswordCB} from "../../ope/auth/ResetPasswordCB";
import {ChangeUserPasswordCB} from "../../ope/auth/ChangeUserPasswordCB";
import {ImpersonateUserCB} from "../../ope/auth/ImpersonateUserCB";
import {RevokeUserSessionsCB} from "../../ope/auth/RevokeUserSessionsCB";

@Injectable({
  providedIn: 'root'
})
export class AuthOpeService extends BaseOPEService {

  resetPassword(cb: ResetPasswordCB) {
    return this.execOPE(cb);
  }

  saveNewPassword(cb: SaveNewPasswordCB, token: string) {
    return this.execOPEWithTempToken(cb, token);
  }

  public changeUserPassword(cb: ChangeUserPasswordCB): Promise<any> {
    return this.execOPE(cb);
  }

  public impersonateUser(cb: ImpersonateUserCB): Promise<any> {
    return this.execOPE(cb);
  }

  public revokeUserSessions(cb: RevokeUserSessionsCB): Promise<any> {
    return this.execOPE(cb);
  }

  login(user: string, pswd: string, rememberMe: boolean, hashPassword = true): Promise<SpringLoginResponse> {
    return new Promise<SpringLoginResponse>((resolve, reject) => {
      this.authState.login(user, pswd, rememberMe, hashPassword).then((response: SpringLoginResponse) => {
        resolve(response);
      }, (error) => {
        this.manageAuthError(error as SpringLoginResponse);
        reject(error);
      });
    })
  }

  setLanguage(locale: string): void {
    this.be.setLanguage(locale);
  }

  hashPassword(pwd: string): string {
    return this.be.hashPassword(pwd);
  }

  private manageAuthError(error: SpringLoginResponse) {

    let errorMessage: string = "";

    switch (error.statusCode) {
      case 0:
        errorMessage = 'ERROR.CONNECTION_ERROR';
        break;
      case 401:
        if (error.error) {
          errorMessage = error.error;
        } else {
          errorMessage = 'ERROR.CREDENTIALS_ERROR';
        }
        break;
      case 403:
        if (error.error) {
          errorMessage = error.error;
        } else {
          errorMessage = 'ERROR.FORBIDDEN';
        }
        break;
      default:
        console.error(error.error!);
        errorMessage = 'ERROR.GENERIC_ERROR';
    }

    this.toastService.openTranslatedErrorToastMessage(errorMessage);

    return error;
  }
}
